import React, {useContext} from 'react';
import {defineMessages} from 'react-intl';
import {AccessControlIndicator, defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';
import {useOtpGuard} from '@igp/shared/auth';
import {Button} from '@igp/shared/components/button';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ModalContext} from '@igp/shared/components/modal';

import {groups, withAccessCheck} from '@access-control';

import {EditUserForm} from './EditUserForm';

const localized = defineMessages({
    label: {
        id: 'AddUserButton_label',
        defaultMessage: 'Add User',
    },
    modalTitle: {
        id: 'AddUserButton_modalTitle',
        defaultMessage: 'Add new user',
    },
});

function AddUserButtonInner() {
    const {openModal, isModalOpened} = useContext(ModalContext);
    const {verifyOtp} = useOtpGuard();

    function handleClick() {
        if (verifyOtp()) {
            openModal({
                title: <LocalizedText label={localized.modalTitle} />,
                body: <EditUserForm />,
            });
        }
    }

    return <Button onClick={handleClick} label={localized.label} disabled={isModalOpened} color="primary" />;
}

export const addUserButtonResource = defineAccessControlledResource({
    name: 'AddUserButton',
    rules: new GroupAccessRule([groups.adminsGroup]),
});

export const AddUserButton = withAccessCheck(AddUserButtonInner, addUserButtonResource, AccessControlIndicator.Hidden);
